export default __webpack_public_path__ + "static/media/M_R-Black.e9ca59c7.png";